import type { FoundingProgram } from "./types";

export const FOUNDING_REPORT_QUERY_KEY = ["founding", "report"] as const;
export const FOUNDING_ACCOUNT_QUERY_KEY = ["founding", "account"] as const;
export const FOUNDING_ENROLLMENT_QUERY_KEY = ["founding", "enrollment"] as const;
export const OWNER_PROPERTIES_QUERY_KEY = ["founding", "owner-properties"] as const;
export const FOUNDING_RATES_QUERY_KEY = ["founding", "rates"] as const;

export const OWNER_PROPERTIES_PAGE_SIZE = 50;

export const FOUNDING_PROGRAMS: readonly FoundingProgram[] = ["FOUNDING_HOST", "PORTFOLIO_CUSTOM"];

export const MIN_DISCOUNT_PERCENT = 1;
export const MAX_DISCOUNT_PERCENT = 99;

/**
 * Display-only placeholders for the assign dialog's intro/ongoing inputs while
 * the configured defaults (`useFoundingRates`) are still loading. They are
 * never submitted — `canSubmit` stays false until the fields hold real values.
 */
export const FOUNDING_INTRO_PLACEHOLDER = 50;
export const FOUNDING_ONGOING_PLACEHOLDER = 25;
